import { render, staticRenderFns } from "./find-password.vue?vue&type=template&id=6a43c67e&scoped=true"
import script from "./find-password.vue?vue&type=script&lang=js"
export * from "./find-password.vue?vue&type=script&lang=js"
import style0 from "./find-password.vue?vue&type=style&index=0&id=6a43c67e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a43c67e",
  null
  
)

export default component.exports